import React from "react"
import {
  connectHits,
  connectSearchBox,
  connectStateResults,
} from "react-instantsearch-dom"
import { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { Margin } from "styled-components-spacing/dist/cjs"

import karbonLogo from "../../images/karbon-logo.svg"
import { H3 } from "../atoms/Headings"
import { Link } from "../atoms/Link"
import { BannerDisplay } from "../collection/Banner"
import { CAROUSEL_LG_BREAKPOINT } from "../collection/Jumbotron"
import { Slat } from "../template/Slat"
import { WorkbookSlat } from "../template/WorkbookSlat"

const linkResolver = require("../../utils/linkResolver")
const qs = require("qs")

const TopResult = ({ template }) => {
  return (
    <Link to={linkResolver(template.internal.type, template.slug)}>
      <div
        css={css`
          display: grid;
          grid-gap: 16px;

          ${breakpoint("md")(css`
            grid-template-columns: repeat(2, 1fr);
          `)}

          @media (min-width: ${CAROUSEL_LG_BREAKPOINT}px) {
            grid-template-columns: repeat(3, 1fr);
          }
        `}
      >
        <div
          css={css`
            color: black;
            border-radius: 6px;
            background-color: ${props => props.theme.colors.ash};
            background-image: url("${karbonLogo}");
            background-repeat: no-repeat;
            background-size: auto 60px;
            background-position: 16px center;
            width: 100%;
            height: 96px;
            display: flex;
            align-items: center;
            padding: 0 16px 0 86px;
          `}
        >
          <H3
            mb={0}
            mt={0}
            css={css`
              font-weight: 400;
              line-height: 24px;
            `}
          >
            {template.title}
          </H3>
        </div>
      </div>
    </Link>
  )
}

const Hits = ({ hits }) => {
  const templateResults = []
  const templateCollectionResults = []
  const kpiWorkbookResults = []
  const topResult = hits[0]
  const remainingResults = hits.slice(1)

  for (const hit of remainingResults) {
    if (hit.internal.type === "ContentfulKpiWorkbook") {
      kpiWorkbookResults.push(hit)
    } else if (hit.internal.type === "ContentfulTemplate") {
      templateResults.push(hit)
    } else {
      templateCollectionResults.push(hit)
    }
  }

  return (
    <Margin bottom={4}>
      {topResult && (
        <>
          <H3>Top Result</H3>
          {topResult.internal.type === "ContentfulKpiWorkbook" && (
            <WorkbookSlat first key={topResult.objectID} workbook={topResult} />
          )}
          {topResult.internal.type === "ContentfulTemplate" && (
            <Slat first key={topResult.objectID} template={topResult} />
          )}
          {topResult.internal.type !== "ContentfulTemplate" &&
            topResult.internal.type !== "ContentfulKpiWorkbook" && (
              <TopResult template={topResult} />
            )}
        </>
      )}

      {kpiWorkbookResults.length > 0 && (
        <>
          <H3>KPI Dashboards</H3>
          {kpiWorkbookResults.map((hit, i) => (
            <WorkbookSlat first={i === 0} key={hit.objectID} workbook={hit} />
          ))}
        </>
      )}
      {templateResults.length > 0 && (
        <>
          <H3>Templates</H3>
          {templateResults.map((hit, i) => (
            <Slat first={i === 0} key={hit.objectID} template={hit} />
          ))}
        </>
      )}
      {templateCollectionResults.length > 0 && (
        <>
          <H3 mt={3}>Template Collections</H3>
          <BannerDisplay templates={templateCollectionResults} />
        </>
      )}
    </Margin>
  )
}

const CustomHits = connectHits(Hits)

const NoResults = connectSearchBox(
  ({ currentRefinement, refine, className, shouldShow }) => {
    const terms = [
      "Client onboarding",
      "Payroll",
      "Monthly accounting",
      "Advisory",
    ]
    if (shouldShow) {
      return (
        <div className={className}>
          <H3>
            There are no results for &ldquo;{currentRefinement}&rdquo;. Popular
            search terms:
          </H3>

          {terms.map(t => (
            <Link as={"div"} underlined onClick={() => refine(t)} key={t}>
              {t}
            </Link>
          ))}
        </div>
      )
    }
    return null
  }
)

export const Results = connectStateResults(
  ({ searchState, searchResults, children }) => {
    if (searchState.query) {
      return (
        <>
          <NoResults shouldShow={searchResults?.nbHits === 0} />
          <CustomHits />
        </>
      )
    }

    return children
  }
)

const StateResults = ({ searchState }) => searchState.query
export const SearchQuery = connectStateResults(StateResults)

// Search state fuckery

const createURL = state => `?${qs.stringify(state)}`

export const searchStateToUrl = (location, searchState) => {
  return searchState.query
    ? `${location.pathname}${createURL({ query: searchState.query })}`
    : location.pathname
}

export const urlToSearchState = ({ search }) => qs.parse(search.slice(1))
